/** Purpose of a funnel stage, orthogonal to won/lost (E2 RF-14). Mirrors the backend enum. */
export enum StageKindEnum {
  QUALIFICATION_GATE = 'QUALIFICATION_GATE',
  PRESENTATION = 'PRESENTATION',
  PROPOSAL = 'PROPOSAL',
}
